import React, { useEffect, useState } from "react";
import { Table, Tooltip } from "antd";
import ReactPaginate from "react-js-pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import { FaEye } from "react-icons/fa";
import { MdAutoDelete, MdDelete, MdEdit } from "react-icons/md";
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowUnsorted,
} from "react-icons/ti";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import ModalPopup from "../../Common/Modal/Modal";
import { GetAdminLogs } from "../../../Api/SuperAdminVault/LogBook";
import { MdDownload } from "react-icons/md";
import { MdOutlineAddCircleOutline } from "react-icons/md";
import { IoMdShareAlt } from "react-icons/io";

const LogBook = ({
  typeFilter = "",
}) => {
  const dispatch = useDispatch();

  const logs = useSelector(
    (state) => state.crm.admin_activity_log || []
  );

  const pageContext = useSelector(
    (state) => state.crm.admin_logs_page_context || {}
  );  

  const [activePage, setActivePage] = useState(1);
  const [sortOrder, setSortOrder] = useState("D");
  const [sortColumn, setSortColumn] = useState("cred_id");
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [selectedCredential, setSelectedCredential] = useState(null);
const [secretModalOpen, setSecretModalOpen] = useState(false);
const [selectedCredId, setSelectedCredId] = useState(null);
const [sortOrderDate, setSortOrderDate] = useState(null);
const [sortedData, setSortedData] = useState([]);
  const itemsPerPage = 10;

  const totalItems = Number(pageContext?.totalRecords || 0);

  const typeLabelMap = {
    api_key: "API Key",
    login: "Login",
    database: "Database",
    cloud: "Cloud",
    token: "Token",
  };

  const fetchAdminLogs = async (pageNo = activePage) => {
    await GetAdminLogs({dispatch,typeFilter,page:pageNo,limit:itemsPerPage})
  };

  useEffect(() => {
    setActivePage(1);
    setSortedData([]);
    resetSort();
    fetchAdminLogs(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeFilter, sortOrder, sortColumn]);

  useEffect(() => {
    if (activePage !== 1) {
      fetchAdminLogs(activePage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage]);

  const handlePageChange = async(pageNumber) => {
    setActivePage(pageNumber);
    setSortedData([])
    resetSort()
    await GetAdminLogs({dispatch,typeFilter, page:pageNumber,limit:itemsPerPage,})
  };

  const handleSort = (column) => {
    setActivePage(1);

    if (sortColumn !== column) {
      setSortColumn(column);
      setSortOrder("A");
      return;
    }

    if (sortOrder === "A") {
      setSortOrder("D");
      return;
    }

    setSortColumn("cred_id");
    setSortOrder("D");
  };

  const SortIcon = ({ order }) => {
    if (order === "ascend") {
      return (
        <Tooltip
          placement="top"
          title="Ascending"
          overlayStyle={{ pointerEvents: "none" }}
          color="white"
          overlayInnerStyle={{ color: "#1F487C" }}
        >
          <TiArrowSortedUp />
        </Tooltip>
      );
    }
  
    if (order === "descend") {
      return (
        <Tooltip
          placement="top"
          title="Descending"
          overlayStyle={{ pointerEvents: "none" }}
          color="white"
          overlayInnerStyle={{ color: "#1F487C" }}
        >
          <TiArrowSortedDown />
        </Tooltip>
      );
    }
  
    return (
      <Tooltip
        placement="top"
        title="Unsorted"
        overlayStyle={{ pointerEvents: "none" }}
        color="white"
        overlayInnerStyle={{ color: "#1F487C" }}
      >
        <TiArrowUnsorted />
      </Tooltip>
    );
  };

  const renderSortIcon = (column) => {
    if (sortColumn !== column) {
      return (
        <Tooltip
          placement="top"
          title="Unsorted"
          overlayStyle={{ pointerEvents: "none" }}
          color="white"
          overlayInnerStyle={{ color: "#1F487C" }}
        >
          <TiArrowUnsorted />
        </Tooltip>
      );
    }

    if (sortOrder === "A") {
      return (
        <Tooltip
          placement="top"
          title="Ascending"
          overlayStyle={{ pointerEvents: "none" }}
          color="white"
          overlayInnerStyle={{ color: "#1F487C" }}
        >
          <TiArrowSortedUp />
        </Tooltip>
      );
    }

    return (
      <Tooltip
        placement="top"
        title="Descending"
        overlayStyle={{ pointerEvents: "none" }}
        color="white"
        overlayInnerStyle={{ color: "#1F487C" }}
      >
        <TiArrowSortedDown />
      </Tooltip>
    );
  };

  const SortHeader = ({ title, column }) => {
    return (
      <h1 className="text-[1.1vw] font-bold flex items-center justify-evenly">
        {title}
        <button onClick={() => handleSort(column)} className="">
          {renderSortIcon(column)}
        </button>
      </h1>
    );
  };

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
    setSelectedCredential(null);
  };

  const formatDate = (date) => {
    if (!date) return "-";
    return dayjs(date).format("DD MMM, YY");
  };

  const handleViewSecret = (credId) => {
  setSelectedCredId(credId);
  setSecretModalOpen(true);
};

const resetSort = () => {
    setSortOrderDate(null);
  };

const handleDateSort = () => {
    resetSort();

    let sorted = [...logs];

    if (sortOrderDate === "ascend") {
      sorted.sort(
        (a, b) => dayjs(b.createdAt).valueOf() - dayjs(a.createdAt).valueOf(),
      );
      setSortOrderDate("descend");
    } else if (sortOrderDate === "descend") {
      sorted = [...logs];
      setSortOrderDate(null);
    } else {
      sorted.sort(
        (a, b) => dayjs(a.createdAt).valueOf() - dayjs(b.createdAt).valueOf(),
      );
      setSortOrderDate("ascend");
    }

    setSortedData(sorted);
  };
  const activityColumns = [
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          S.No
        </h1>
      ),
      width: "4vw",
      render: (row, rowdta, index) => {
        const serialNumber = (activePage - 1) * itemsPerPage + (index + 1);

        return (
          <div>
            <h1 className="flex justify-center font-bold items-center text-[1vw] text-[#1F487C]">
              {serialNumber}
            </h1>
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          User ID
        </h1>
      ),
      width: "18vw",
      render: (row) => {        
        return (
          <div className="flex items-center justify-center">
            {row?.userId?.length > 18 ? (
              <Tooltip
                placement="top"
                title={row?.userId}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{ color: "#1F487C" }}
              >
                <p className="text-[1vw] font-bold text-[#1F487C]">
                  {`${row?.userId?.slice(0, 18)}...`}
                </p>
              </Tooltip>
            ) : (
              <h1 className="text-[1vw] font-bold text-[#1F487C]">
                {row?.userId || "-"}
              </h1>
            )}
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          Network IP Address
        </h1>
      ),
      width: "18vw",
      render: (row) => {
        return (
          <div className="flex items-center justify-center">
            {/* {row?.ipAddress?.length > 18 ? (
              <Tooltip
                placement="top"
                title={row?.ipAddress}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{ color: "#1F487C" }}
              >
                <p className="text-[1vw] font-bold text-[#1F487C]">
                  {`${row?.ipAddress?.slice(7, 18)}...`}
                </p>
              </Tooltip>
            ) : ( */}
              <h1 className="text-[1vw] font-bold text-[#1F487C]">
                {/* {row?.ipAddress?.slice(7,20) || "-"} */}
                {row?.ipAddress}
              </h1>
            {/* )} */}
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          User Name
        </h1>
      ),
      width: "18vw",
      render: (row) => {
        return (
          <div className="flex items-center justify-center">
            {row?.login_user_name?.length > 18 ? (
              <Tooltip
                placement="top"
                title={row?.login_user_name}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{ color: "#1F487C" }}
              >
                <p className="text-[1vw] font-bold text-[#1F487C]">
                  {`${row?.login_user_name?.slice(0, 18)}...`}
                </p>
              </Tooltip>
            ) : (
              <h1 className="text-[1vw] font-bold text-[#1F487C]">
                {row?.login_user_name || "-"}
              </h1>
            )}
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          Module Name
        </h1>
      ),
      width: "18vw",
      render: (row) => {
        return (
          <div className="flex items-center justify-center">
            {row?.moduleName?.length > 18 ? (
              <Tooltip
                placement="top"
                title={row?.moduleName}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{ color: "#1F487C" }}
              >
                <p className="text-[1vw] font-bold text-[#1F487C]">
                  {`${row?.moduleName?.slice(0, 18)}...`}
                </p>
              </Tooltip>
            ) : (
              <h1 className="text-[1vw] font-bold text-[#1F487C]">
                {row?.moduleName || "-"}
              </h1>
            )}
          </div>
        );
      },
    },
    // {
    //   title: <SortHeader title="Type" column="credential_type" />,
    //   width: "12vw",
    //   render: (row) => {
    //     const typeName =
    //       typeLabelMap[row?.credential_type] || row?.credential_type || "-";

    //     return (
    //       <div className="flex items-center justify-center">
    //         <p className="text-[1vw] font-bold text-[#1F487C]">{typeName}</p>
    //       </div>
    //     );
    //   },
    // },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          Row ID
        </h1>
      ),
      width: "18vw",
      render: (row) => {
        return (
          <div className="flex items-center justify-center">
            {row?.changesMadeFor?.length > 18 ? (
              <Tooltip
                placement="top"
                title={row?.changesMadeFor}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{ color: "#1F487C" }}
              >
                <p className="text-[1vw] font-bold text-[#1F487C]">
                  {`${row?.changesMadeFor?.slice(0, 18)}...`}
                </p>
              </Tooltip>
            ) : (
              <h1 className="text-[1vw] font-bold text-[#1F487C]">
                {row?.changesMadeFor || "-"}
              </h1>
            )}
          </div>
        );
      },
    },
    // {
    //   title: <SortHeader title="Captured" column="createdAt" />,
    //   width: "12vw",
    //   render: (row) => {
    //     return (
    //       <div className="flex items-center justify-center">
    //         <p className="text-[1vw] text-[#1F487C]">
    //           {formatDate(row?.createdAt)}
    //         </p>
    //       </div>
    //     );
    //   },
    // },
    {
          title: (
            <h1 className="text-[1.1vw] font-bold flex items-center justify-evenly">
              Captured
              <button onClick={handleDateSort}>
                <SortIcon order={sortOrderDate} />
              </button>
            </h1>
          ),
          width: "16vw",
          render: (row) => (
            <p className="text-[1vw] text-[#1F487C] flex justify-center">
              {row.createdAt ? dayjs(row.createdAt).format("DD MMM YYYY (hh:mm A)") : "-"}
            </p>
          ),
        },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold text-center flex items-center justify-center">
          Action Made
        </h1>
      ),
      width: "10vw",
      render: (row) => {
        return (
          <div className="flex items-center justify-center">

            {row?.action?.includes("Add") && <Tooltip
                placement="top"
                title={row?.action}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{ color: "#1F487C" }}
              >
                <MdOutlineAddCircleOutline    
                    size="1.3vw"
                    color="#1F4B7F"
                    className="cursor-pointer"
                />
              </Tooltip> }
            
            {row?.action?.includes("View") && <Tooltip
                placement="top"
                title={row?.action}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{ color: "#1F487C" }}
              >
                <FaEye
                    size="1.3vw"
                    color="#1F4B7F"
                    className="cursor-pointer"
                />
              </Tooltip> }

            {row?.action?.includes("Update") && <Tooltip
                placement="top"
                title={row?.action}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{ color: "#1F487C" }}
              >
                <MdEdit
              size="1.3vw"
              color="#1F4B7F"
              className="cursor-pointer"
            />
              </Tooltip>}
            

            {row?.action?.includes("Delete") && <Tooltip
                placement="top"
                title={row?.action}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{ color: "#1F487C" }}
              >
                <MdDelete
              size="1.3vw"
              color="#1F4B7F"
              className="cursor-pointer"
            />
              </Tooltip>}

            {row?.action?.includes("Download") && <Tooltip
                placement="top"
                title={row?.action}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{ color: "#1F487C" }}
              >
                <MdDownload 
              size="1.3vw"
              color="#1F4B7F"
              className="cursor-pointer"
            />
              </Tooltip>}

              {(row?.action?.includes("Send") || row?.action?.includes("Share")) && <Tooltip
                placement="top"
                title={row?.action}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{ color: "#1F487C" }}
              >
                <IoMdShareAlt 
              size="1.3vw"
              color="#1F4B7F"
              className="cursor-pointer"
            />
              </Tooltip>}
          </div>
        );
      },
    },
  ];

  const accessColumns = [
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          S.No
        </h1>
      ),
      width: "4vw",
      render: (row, rowdta, index) => {
        const serialNumber = (activePage - 1) * itemsPerPage + (index + 1);

        return (
          <div>
            <h1 className="flex justify-center font-bold items-center text-[1vw] text-[#1F487C]">
              {serialNumber}
            </h1>
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          User ID
        </h1>
      ),
      width: "18vw",
      render: (row) => {
        return (
          <div className="flex items-center justify-center">
            {row?.login_user_id?.length > 18 ? (
              <Tooltip
                placement="top"
                title={row?.login_user_id}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{ color: "#1F487C" }}
              >
                <p className="text-[1vw] font-bold text-[#1F487C]">
                  {`${row?.login_user_id?.slice(0, 18)}...`}
                </p>
              </Tooltip>
            ) : (
              <h1 className="text-[1vw] font-bold text-[#1F487C]">
                {row?.login_user_id || "-"}
              </h1>
            )}
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          Network IP Address
        </h1>
      ),
      width: "18vw",
      render: (row) => {
        return (
          <div className="flex items-center justify-center">
            {/* {row?.ipAddress?.length > 18 ? (
              <Tooltip
                placement="top"
                title={row?.ipAddress}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{ color: "#1F487C" }}
              >
                <p className="text-[1vw] font-bold text-[#1F487C]">
                  {`${row?.ipAddress?.slice(7, 18)}...`}
                </p>
              </Tooltip>
            ) : ( */}
              <h1 className="text-[1vw] font-bold text-[#1F487C]">
                {/* {row?.ipAddress?.slice(7,20) || "-"} */}
                {row?.ipAddress}
              </h1>
            {/* )} */}
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          User Name
        </h1>
      ),
      width: "18vw",
      render: (row) => {
        return (
          <div className="flex items-center justify-center">
            {row?.login_user_name?.length > 18 ? (
              <Tooltip
                placement="top"
                title={row?.login_user_name}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{ color: "#1F487C" }}
              >
                <p className="text-[1vw] font-bold text-[#1F487C]">
                  {`${row?.login_user_name?.slice(0, 18)}...`}
                </p>
              </Tooltip>
            ) : (
              <h1 className="text-[1vw] font-bold text-[#1F487C]">
                {row?.login_user_name || "-"}
              </h1>
            )}
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold flex items-center justify-center">
          Event Type
        </h1>
      ),
      width: "18vw",
      render: (row) => {
        return (
          <div className="flex items-center justify-center">
            {row?.eventType?.length > 18 ? (
              <Tooltip
                placement="top"
                title={row?.eventType}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{ color: "#1F487C" }}
              >
                <p className="text-[1vw] font-bold text-[#1F487C]">
                  {`${row?.eventType?.slice(0, 18)}...`}
                </p>
              </Tooltip>
            ) : (
              <h1 className="text-[1vw] font-bold text-[#1F487C]">
                {row?.eventType || "-"}
              </h1>
            )}
          </div>
        );
      },
    },
    // {
    //   title: <SortHeader title="Type" column="credential_type" />,
    //   width: "12vw",
    //   render: (row) => {
    //     const typeName =
    //       typeLabelMap[row?.credential_type] || row?.credential_type || "-";

    //     return (
    //       <div className="flex items-center justify-center">
    //         <p className="text-[1vw] font-bold text-[#1F487C]">{typeName}</p>
    //       </div>
    //     );
    //   },
    // },
    {
      title: <SortHeader title="Captured" column="createdAt" />,
      width: "14vw",
      render: (row) => {
        return (
          <div className="flex items-center justify-center">
            <p className="text-[1vw] text-[#1F487C]">
              {row?.createdAt ? dayjs(row.createdAt).format("DD MMM YYYY (hh:mm A)") : "-"}
            </p>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Table
        dataSource={logs}
        columns={typeFilter === "activity_logs" ? activityColumns : accessColumns}
        pagination={false}
        className="custom-table"
        rowKey={(row) => row?.cred_id}
        locale={{ emptyText: "No Data Available" }}
      />

      {totalItems > itemsPerPage && (
        <div className="mt-[1vw] justify-between flex items-center">
          <div className="text-[#1F4B7F] flex text-[1.1vw] gap-[0.5vw]">
            <span>Showing</span>
            <span className="font-bold">
              {(activePage - 1) * itemsPerPage + 1} -{" "}
              {Math.min(activePage * itemsPerPage, totalItems)}
            </span>
            <span>from</span>
            <span className="font-bold">{totalItems}</span>
            <span>data</span>
          </div>

          <ReactPaginate
            activePage={activePage}
            itemsCountPerPage={itemsPerPage}
            totalItemsCount={totalItems}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
            itemClass="page-item"
            linkClass="page-link"
            activeClass="active"
            prevPageText={<FontAwesomeIcon icon={faChevronLeft} size="1vw" />}
            nextPageText={<FontAwesomeIcon icon={faChevronRight} size="1vw" />}
            firstPageText={
              <FontAwesomeIcon icon={faAngleDoubleLeft} size="1vw" />
            }
            lastPageText={
              <FontAwesomeIcon icon={faAngleDoubleRight} size="1vw" />
            }
          />
        </div>
      )}

      <ModalPopup
        show={deleteModalIsOpen}
        onClose={closeDeleteModal}
        height="20vw"
        width="30vw"
        closeicon={false}
      >
        <div>
          <div className="flex flex-col justify-center">
            <div className="items-center flex-col flex justify-center mt-[0.5vw]">
              <MdAutoDelete color="#1f4b7f" size="5vw" />

              <p className="text-[1.7vw] font-semibold text-[#1f4b7f] mt-[1vw]">
                Are You Sure ?
              </p>

              <p className="flex justify-center items-center gap-[0.5vw] text-[1.1vw] text-[#1f4b7f] mt-[0.5vw] text-center leading-tight">
                <span>Want to delete this</span>

                {selectedCredential?.credential_name?.length >= 20 ? (
                  <Tooltip
                    placement="top"
                    title={selectedCredential?.credential_name}
                    className="cursor-pointer"
                    color="white"
                    overlayInnerStyle={{ color: "#1F487C" }}
                  >
                    <span>
                      {`${selectedCredential?.credential_name?.slice(
                        0,
                        10
                      )}...`}
                    </span>
                  </Tooltip>
                ) : (
                  <span>{selectedCredential?.credential_name || "-"}</span>
                )}

                <span>?</span>
              </p>
            </div>

            <div className="flex items-center mt-[2vw] gap-[2vw] justify-center">
              <button
                className="border-[#1f4b7f] border-[0.1vw] rounded-[0.5vw] text-[1.1vw] font-semibold text-[#1f4b7f] w-[10vw] h-[3vw]"
                onClick={closeDeleteModal}
              >
                No
              </button>

              <button
                className="bg-[#1f4b7f] text-white font-semibold text-[1.1vw] w-[10vw] h-[3vw] rounded-[0.5vw]"
                onClick={closeDeleteModal}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </ModalPopup>
    </>
  );
};

export default LogBook;